<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <MensagemAlerta class="row-space" v-if="msgAlerta" :mensagem="msgAlerta" />


    <div v-show="!modoInclusao">        
        <div v-if="lsDados.length>0" class="table-wrapper row-space">
            <table>
                <thead>
                    <tr>
                        <th>Data</th>
                        <th>Hora</th>
                        <th>Nome</th>
                        <th>Assunto</th>
                        <th>Situação</th>
                        <th>=</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(obj, index) in lsDados" :key="obj.id" :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0}">
                        <td class="col-width-date center">{{ Funcoes.formatDateFromJson(obj.dtagenda) }}</td>
                        <td class="col-width-char05 center">{{ Funcoes.formatTimeFromJson(obj.hragenda) }}</td>
                        <td>{{ obj.nmpessoa }}</td>
                        <td class="col-width-char40">{{ obj.assunto }}</td>
                        <td class="col-width-char20">{{ obj.nmstatus }}</td>
                        <td class="col-width-acoes1" @click.stop>
                            <RowActionsMenu
                                :item="obj"
                                :actions="acoesPara(obj)"
                                header="Ações"
                                @action="onRowAction"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="row-start">
            <button class="btn-confirm" type="button" @click="setIncluir(0)">Incluir Atendimento</button>
            <button type="button" @click="closeForm">Retornar</button>
        </div>
    </div>
    

    <div v-if="modoInclusao">
        <GabineteAgendaEditPage :idEdicao="idAgendaEdicao" :strData="dataAgenda" @close="modoInclusao = false; lerDados()" />
    </div>
    

    <div>
        <ModalJustificativa
            :visible="showModalCancelamento"
            @update:visible="(value) => (showModalCancelamento = value)"
            @submit="salvarCancelamento" />
    </div>

    <ConfirmModal ref="confirmModal" />
</template>


<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { Funcoes } from '@/funcoes/utils';
import { globalStore } from '@/globals';
import ConfirmModal from '@/components/modals/ConfirmModal.vue';
import GabineteAgendaEditPage from './GabineteAgendaEditPage.vue'
import MensagemAlerta from '@/components/MensagemAlerta.vue';
import ModalJustificativa from '@/components/modals/ModalJustificativa.vue';
import RowActionsMenu from '@/components/RowActionsMenu.vue';

const emit = defineEmits(['close']);

const confirmModal = ref(null);

const dataAgenda = ref(Funcoes.strDataAtual());
const msgAlerta = ref(null);
const idAgendaAcao = ref(0);
const idAgendaEdicao = ref(0);
const isLoading = ref(false);
const lsDados = ref([]);
const modoInclusao = ref(false);
const showModalCancelamento = ref(false);


function acoesPara(obj) {
  return [
    { key: 'alterar', label: 'Alterar', icon: '✏️', visible: obj.idstatus <= 3 },
    { key: 'aguardando', label: 'Definir aguardando', icon: '🕘', visible: obj.idstatus <= 2 },
    { key: 'iniciar', label: 'Iniciar atendimento', icon: '▶️', visible: obj.idstatus <= 3 },
    { key: 'cancelar', label: 'Cancelar', icon: '❌', variant: 'danger', visible: obj.idstatus <= 3 }
  ];
}


async function abrirModal() {
    const confirmado = await confirmModal.value.show({
        message: 'Confirma o início do atendimento?',
        confirmText: 'Sim',
        cancelText: 'Não'
    })

    if (confirmado) {
        salvarIniciar();  
    }
}


async function abrirModalAguardando() {
    const confirmado = await confirmModal.value.show({
        message: 'Confirma pessoa aguardando?',
        confirmText: 'Sim',
        cancelText: 'Não'
    })

    if (confirmado) {
        salvarAguardando();  
    }
}


function closeForm(){emit('close');}


async function lerDados() {
    try{
        msgAlerta.value = null;
        isLoading.value = true;
        const req = await Api.genericPost('/listas/gabinete_agenda', {
            idmunicipio: globalStore.idmunicipio,
            datainicial: dataAgenda.value, 
            datafinal:dataAgenda.value});
        lsDados.value = req;
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value = false;}
}


function onRowAction({ key, item }) {
    idAgendaAcao.value = item.id;
    if (key === 'alterar') setIncluir(item.id);
    else if (key === 'aguardando') {abrirModalAguardando();}
    else if (key === 'iniciar') {abrirModal();}
    else if (key === 'cancelar') {showModalCancelamento.value = true;}
}


async function salvarCancelamento({justificativa}){
    try{
        msgAlerta.value=null;
        isLoading.value=true;
        const r = await Api.genericPut('/cad/gabinete_agenda', {
            id: idAgendaAcao.value, 
            lgcancelamento: globalStore.idlogin, 
            obcancelamento: justificativa});
        if (r.bolok==1){
            lerDados();
        }else{msgAlerta.value=r.erro}
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    }finally{isLoading.value=false;}
}


async function salvarAguardando(){
    try{
        msgAlerta.value=null;
        isLoading.value=true;
        const r = await Api.genericPut('/cad/gabinete_agenda', {
            id: idAgendaAcao.value,
            lgchegada: globalStore.idlogin,
            idlogin: globalStore.idlogin});
        if (r.bolok==1){
            lerDados();
        }else{msgAlerta.value=r.erro}
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    }finally{isLoading.value=false;}
}


async function salvarIniciar(){
    try{
        msgAlerta.value=null;
        isLoading.value=true;
        const r = await Api.genericPost('/gabinete/agenda/atendimento/iniciar', {
            idmunicipio: globalStore.idmunicipio,
            id: idAgendaAcao.value,
            idlogin: globalStore.idlogin,
            idusuario: globalStore.idusuario});
        if (r.bolok==1){
            lerDados();
        }else{msgAlerta.value=r.erro}
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    }finally{isLoading.value=false;}
}


function setIncluir(id){
    idAgendaEdicao.value = id;
    modoInclusao.value = true;
}


onMounted(lerDados);
</script>
